import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
export default (({
  fill
}) => /*#__PURE__*/React.createElement(Svg, {
  width: "23",
  height: "23",
  viewBox: "0 0 24 24",
  fill: "none"
}, /*#__PURE__*/React.createElement(Path, {
  d: "M13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29-4.3 4.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4.29-4.3 4.29 4.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42z",
  fill: fill
})));
//# sourceMappingURL=Close.js.map